// extracted by mini-css-extract-plugin
export default {"Paginator":"Paginator_Paginator__X9bHW","paginateButton":"Paginator_paginateButton__-akTX"};